export default [
  {
    name: 'Job.Vacancies',
    path: 'vacancies',
    component: () => import('./components/vacancies/List')
  },
  {
    name: 'Job.Vacancies.Edit',
    path: 'vacancies/:id?/edit',
    props: true,
    component: () => import('./components/vacancies/Edit')
  }
  ,
  {
    name: 'Job.Stories',
    path: 'stories',
    component: () => import('./components/stories/List')
  },
  {
    name: 'Job.Stories.Edit',
    path: 'stories/:id?/edit',
    props: true,
    component: () => import('./components/stories/Edit')
  }
]
